
      import PenEdit from './pen-edit.vue'
      import type { App, Plugin } from 'vue'

      export const PenEditPlugin: Plugin = {
        install(app: App) {
          app.component('PenEdit', PenEdit)
        },
      }
      export { PenEdit }
      